/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
  width: calc(460rem/14);
  min-width: calc(50rem/14);
}
:host .pl_label, :host .pl_report {
  font-size: inherit;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  line-height: calc(22rem/14);
}
:host .pl_horizontal {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
}
:host .pl_horizontal .pl_outer {
  flex: 1 1 auto;
  height: calc(8rem/14);
  width: 100%;
  position: relative;
  background: #C5CACC;
  background: var(--davinci-color-outline-light, #C5CACC);
  margin-right: calc(12rem/14);
}
:host .pl_horizontal .pl_outer .pl_inner {
  height: calc(8rem/14);
  position: relative;
  background-color: #007CC1;
  background-color: var(--davinci-color-primary, #007CC1);
}

.pl_horizontal ::slotted(*) {
  flex: 0 0 auto;
}

:host([hidden]) {
  display: none;
}`;
export { style };
